import { render, staticRenderFns } from "./ReportTableChildren.vue?vue&type=template&id=35031379&scoped=true&"
import script from "./ReportTableChildren.vue?vue&type=script&lang=js&"
export * from "./ReportTableChildren.vue?vue&type=script&lang=js&"
import style0 from "./ReportTableChildren.vue?vue&type=style&index=0&id=35031379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35031379",
  null
  
)

export default component.exports